
/** @conver joinbox - Decided to use Gearwheel everywhere (Join button always in the bottom left).  7/17/13 	**/
/** @conver member page URL 	- https://www.s.socialpsychology.org/member/sfarthing 				7/17/13 	**/
/** @conver use "sign in" rather than "login" or "log in" 7/17/13 **/
// @todo make the join box a requirejs module.

define('views/template/topHeader/joinbox/index',["text!./loggedIn.html", "text!./notLoggedIn.html", "models/session"],
function(loggedInTemplate, notLoggedInTemplate, SessionModel) {

	return Backbone.View.extend({

		initialize: function() {

			this.session = (this.options.sessionModel ? this.options.sessionModel : new SessionModel());
			this.user 	= this.session.getHttpCookie();

			if(!this.user || !this.session.getId()) {
				this.$el.html(_.template(notLoggedInTemplate, {}));
			} else {

				// @todo If the session doesn't have the photoid field set lets query it.
				if(	typeof this.user.photoid 	 == "undefined" 	||
					typeof this.user.password 	 == "undefined" 	||
					typeof this.user.orientation == "undefined") {

					this.session.updateHttpCookie(true, _.bind(function() {
						this.user 	= this.session.getHttpCookie();
						this.renderLoggedIn();
					}, this));
				} else {
					this.renderLoggedIn();
				}

			}

			this.session.on("cookieupdate", function() {
				this.user 	= this.session.getHttpCookie();
				this.renderLoggedIn();
			}, this);

		},


		renderLoggedIn: function() {
			this.$el.html(_.template(loggedInTemplate, _.extend({user: this.user}, {})));

			var joinbox = this.$el.closest(".joinbox");

			joinbox.removeClass("photo");
			joinbox.find("> a:first-child img").remove();

			var photo_url;
			if(this.user.photoid) {
				if(this.user.profileid) {
					username = this.user.username;
					// If the username contains "." lets use the photoid for https
					if (username.indexOf(".")>0){
						username = username.replace(".","-");
						photo_url = "https://"+username+"."+window.config.rootdomain+"/"+this.user.photoid+ "/photo.jpg";
					} else {
						photo_url = "https://"+username+"."+window.config.rootdomain+"/photo.jpg";
					}
				} else if(this.user.member_profileid) {
					photo_url = "https://www."+window.config.rootdomain+"/member/"+this.user.username+"/"+this.user.photoid+"/photo.jpg";
				}

				joinbox.prepend($("<img>").attr("src", photo_url));
				// there is a second unsecure image being posted, lets remove it

			}


		}


	});

})
;